export const PARENT_RELATIONSHIP_OPTIONS = [
  { value: 'issued_under', label: 'Issued under parent' },
  { value: 'amends', label: 'Amends parent' },
  { value: 'sow_under', label: 'SOW under parent' },
  { value: 'order_form_under', label: 'Order form under parent' },
  { value: 'supplements', label: 'Supplements parent' },
];

export function inferParentRelationshipType({
  relationshipType,
  contractType,
  parentReferenceText,
  title,
  shortName,
} = {}) {
  if (relationshipType) return relationshipType;
  const text = [contractType, parentReferenceText, title, shortName]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  if (/\bamend(?:ment|s|ed|ing)?\b/.test(text)) return 'amends';
  if (/\bsow\b|\bstatement\s+of\s+work\b/.test(text)) return 'sow_under';
  if (/\border\s+form\b/.test(text)) return 'order_form_under';
  if (/\bsupplement(?:s|al|ed|ing)?\b/.test(text)) return 'supplements';
  return 'issued_under';
}

export function parentRelationshipMeta(input = {}) {
  const type = inferParentRelationshipType(input);
  switch (type) {
    case 'amends':
      return {
        type,
        parentLabel: 'Amendment to',
        childLabel: 'Amendment',
        chipLabel: 'Amendment',
        chipClass: 'purple',
      };
    case 'sow_under':
      return {
        type,
        parentLabel: 'SOW under',
        childLabel: 'SOW',
        chipLabel: 'SOW',
        chipClass: 'blue',
      };
    case 'order_form_under':
      return {
        type,
        parentLabel: 'Order form under',
        childLabel: 'Order form',
        chipLabel: 'Order Form',
        chipClass: 'blue',
      };
    case 'supplements':
      return {
        type,
        parentLabel: 'Supplement to',
        childLabel: 'Supplement',
        chipLabel: 'Supplement',
        chipClass: 'green',
      };
    case 'issued_under':
    default:
      return {
        type: 'issued_under',
        parentLabel: 'Issued under',
        childLabel: 'Issued under',
        chipLabel: 'Child',
        chipClass: 'gray',
      };
  }
}
